import { render, staticRenderFns } from "./BoxAlerts.vue?vue&type=template&id=1a2a400e&scoped=true"
import script from "./BoxAlerts.vue?vue&type=script&lang=js"
export * from "./BoxAlerts.vue?vue&type=script&lang=js"
import style0 from "./BoxAlerts.vue?vue&type=style&index=0&id=1a2a400e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2a400e",
  null
  
)

export default component.exports